/**
 * KPMG DDS Vuetify theme definition.
 *
 * Internalized from kpmg-dds 3.1.7 so that external package can be dropped
 * and Vue / Vuetify versions can be freely updated.
 */
export const KPMGDDSTheme = {
  dark: false,
  colors: {
    primary: "#303F9F",
    secondary: "#01579B",
    info: "#42A5F5",
    success: "#388E3C",
    warning: "#FFB300",
    error: "#E64A19",
    surface: "#FFFFFF",
    background: "#F7F8F9",

    /* Success */
    "kpmgSuccess-900": "#388E3C",
    "kpmgSuccess-100": "#E8F5E9",

    /* Warning */
    "kpmgWarning-900": "#FFB300",
    "kpmgWarning-100": "#FFF8E1",

    /* Error */
    "kpmgError-900": "#C62828",
    "kpmgError-100": "#FFEBEE",

    /* Neutrals */
    "neutral-50": "#F7F8F9",
    "neutral-100": "#F1F2F4",
    "neutral-200": "#DCDFE4",
    "neutral-300": "#B3B9C4",
    "neutral-400": "#8590A2",
    "neutral-500": "#758195",
    "neutral-600": "#626F86",
    "neutral-700": "#44546F",
    "neutral-800": "#2C3E5D",
    "neutral-900": "#091E42",

    /* Primary */
    "kpmgPrimary-900": "#1A237E",
    "kpmgPrimary-700": "#303F9F",
    "kpmgPrimary-500": "#5C6BC0",
    "kpmgPrimary-300": "#9FA8DA",
    "kpmgPrimary-200": "#C5CAE9",
    "kpmgPrimary-100": "#E8EAF6",

    /* Secondary */
    "kpmgSecondary-900": "#01579B",
    "kpmgSecondary-700": "#0288D1",
    "kpmgSecondary-500": "#29B6F6",
    "kpmgSecondary-300": "#81D4FA",
    "kpmgSecondary-100": "#E1F5FE",

    /* Tertiary */
    "kpmgTertiary-900": "#0D47A1",
    "kpmgTertiary-700": "#1976D2",
    "kpmgTertiary-500": "#42A5F5",
    "kpmgTertiary-300": "#90CAF9",
    "kpmgTertiary-100": "#E3F2FD",

    /* Accent */
    "kpmgAccent-900": "#EC407A",
    "kpmgAccent-700": "#F06292",
    "kpmgAccent-500": "#F48FB1",
    "kpmgAccent-300": "#F8BBD0",
    "kpmgAccent-100": "#FCE4EC",

    /* Purple */
    "kpmgPurple-900": "#5E35B1",
    "kpmgPurple-700": "#7E57C2",
    "kpmgPurple-500": "#9575CD",
    "kpmgPurple-300": "#B39DDB",
    "kpmgPurple-100": "#D1C4E9",
  },
}
